import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'
import { ehErroDeChunkVelho, recarregarUmaVezPorChunkVelho } from './lib/chunkVelho'

/**
 * Aba aberta durante um deploy pede o chunk antigo, que nao existe mais, e a
 * navegacao morre com "Esta pagina falhou". O Vite avisa por este evento antes
 * de o erro subir para o React, entao da para recarregar sem o usuario ver
 * tela de erro nenhuma. O ErrorBoundary trata o caso que escapa daqui.
 */
window.addEventListener('vite:preloadError', () => {
  recarregarUmaVezPorChunkVelho()
})

// Import dinamico que falha fora do ciclo do React (por exemplo, um prefetch)
// chega como rejeicao nao tratada, nao como erro de render.
window.addEventListener('unhandledrejection', (evento) => {
  if (ehErroDeChunkVelho(evento.reason)) recarregarUmaVezPorChunkVelho()
})

// Sentry: inicializa apenas se DSN configurado (no-op em dev/local por padrão)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
